
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1sxt8_1qieo_189",
  "header": "awsui_header_1sxt8_1qieo_222",
  "with-additional-action": "awsui_with-additional-action_1sxt8_1qieo_238",
  "with-runtime-context": "awsui_with-runtime-context_1sxt8_1qieo_246",
  "with-toolbar": "awsui_with-toolbar_1sxt8_1qieo_249",
  "header-actions": "awsui_header-actions_1sxt8_1qieo_267",
  "content-with-paddings": "awsui_content-with-paddings_1sxt8_1qieo_273",
  "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_1qieo_280"
};
  